import { LegalProceedingService } from "@/services/legalProceeding";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { legalProceedingsQueryKey } from "../usePaginatedLegalProceedingsQuery";
import { getCasesQueryKey } from "@/hooks/lexZap/useLexZapCases";

export const useReactivateMonitoring = () => {
  const api = LegalProceedingService;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["reactivateMonitoring"],
    mutationFn: async () => await api.reactivateMonitoring(),
    onSuccess: () => {
      // legalProceedingsQueryKey is a PREFIX of the monitored-count and
      // monitoring-statuses query keys, so this single invalidate also refreshes
      // the banners' N and the per-case pause badges after a reactivation.
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: legalProceedingsQueryKey }),
        queryClient.invalidateQueries({ queryKey: getCasesQueryKey() }),
      ]);
    },
  });
};
